(function (){
    'use strict';

    angular
        .module('huddle', [
            'ui.router',
            'ui.bootstrap',
            'ngDialog',
            'ui.select',
            'ngSanitize',
            'vAccordion',
            'ngAnimate',
            'ui.footable',
            'daterangepicker',
            'angular.morris',
            'angularFileUpload',
            'ui.bootstrap.datetimepicker',
            'ui.dateTimeInput',
            '720kb.tooltips',
            'datatables'
        ]);
})();